import { parseZohoHoursToMinutes } from './projectBudget';

// Boss battle i bundbaren. Bossen er det "Fast pris"-projekt, brugeren har logget flest timer på de
// seneste 7 dage. HP er projektets reelle restbudget plus de timer, brugeren har logget men endnu ikke
// "kastet" (mana), så summen passer med Zoho. Alle timer i funktionerne her er decimaltimer.
export const MANA_COST = 4;
export const WINDOW_DAYS = 7;

const hoursOf = (ev) => (new Date(ev.end) - new Date(ev.start)) / 3600000;
const hasBuffer = (p) => p.buffer20 === true || p.buffer20 === 'true';
const countable = (ev, isOutlookSyncEvent) =>
  ev && !ev.isPeople && !ev.logId?.startsWith?.('temp-') && ev.projectId && !isOutlookSyncEvent(ev) && hoursOf(ev) > 0;

// Projektets budget i timer. Med "20% Buffer" er det 120 %: bufferen er bossens ekstra HP (beslutning D).
export function bossBudgetHours(project) {
  const minutes = parseZohoHoursToMinutes(project?.budgetedHours);
  return (hasBuffer(project || {}) ? minutes * 1.2 : minutes) / 60;
}

// Flest Projects-timer de seneste 7 dage (rullende, inkl. i dag) på et "Fast pris"-projekt med budget.
// Uafgjort: det senest loggede. Returnerer { project, hours } eller null.
export function pickBossProject({ events, projects, now = new Date(), isOutlookSyncEvent = () => false }) {
  const from = new Date(now.getFullYear(), now.getMonth(), now.getDate() - (WINDOW_DAYS - 1));
  const to = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  const byProject = new Map();
  (events || []).forEach((ev) => {
    if (!countable(ev, isOutlookSyncEvent)) return;
    const start = new Date(ev.start);
    if (start < from || start >= to) return;
    const cur = byProject.get(ev.projectId) || { hours: 0, last: 0 };
    cur.hours += hoursOf(ev);
    cur.last = Math.max(cur.last, start.getTime());
    byProject.set(ev.projectId, cur);
  });

  let best = null;
  byProject.forEach((v, id) => {
    const project = (projects || []).find((p) => p.id === id);
    if (!project || project.fakturering !== 'Fast pris' || !(parseZohoHoursToMinutes(project.budgetedHours) > 0)) return;
    if (!best || v.hours > best.hours + 1e-9 || (Math.abs(v.hours - best.hours) <= 1e-9 && v.last > best.last)) {
      best = { project, hours: v.hours, last: v.last };
    }
  });
  return best && { project: best.project, hours: best.hours };
}

// Brugerens egne Projects-timer på projektet i indeværende år.
export function myProjectHours({ events, projectId, now = new Date(), isOutlookSyncEvent = () => false }) {
  const year = now.getFullYear();
  return (events || []).reduce((sum, ev) => (
    countable(ev, isOutlookSyncEvent) && ev.projectId === projectId && new Date(ev.start).getFullYear() === year
      ? sum + hoursOf(ev) : sum
  ), 0);
}

export function bossStats({ project, myHours, castHours, manaCost = MANA_COST }) {
  const budget = bossBudgetHours(project);
  const actual = parseZohoHoursToMinutes(project.actualHours) / 60;
  const mana = Math.max(0, myHours - castHours);
  const hp = Math.max(0, budget - actual + mana);
  return {
    budget,
    mana,
    spellsReady: Math.floor(mana / manaCost + 1e-9),
    hp,
    hpPct: budget > 0 ? Math.min(100, (hp / budget) * 100) : 0,
    defeated: budget - actual + mana <= 1e-9,
  };
}
